var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFluentBot24Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#3F8BC7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6741_37971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.667 22.6666C10.667 21.2521 11.2289 19.8956 12.2291 18.8954C13.2293 17.8952 14.5858 17.3333 16.0003 17.3333C17.4148 17.3333 18.7714 17.8952 19.7716 18.8954C20.7718 19.8956 21.3337 21.2521 21.3337 22.6666H20.0003C20.0003 21.6058 19.5789 20.5883 18.8288 19.8382C18.0786 19.0881 17.0612 18.6666 16.0003 18.6666C14.9395 18.6666 13.922 19.0881 13.1719 19.8382C12.4218 20.5883 12.0003 21.6058 12.0003 22.6666H10.667ZM16.0003 16.6666C13.7903 16.6666 12.0003 14.8766 12.0003 12.6666C12.0003 10.4566 13.7903 8.66663 16.0003 8.66663C18.2103 8.66663 20.0003 10.4566 20.0003 12.6666C20.0003 14.8766 18.2103 16.6666 16.0003 16.6666ZM16.0003 15.3333C17.4737 15.3333 18.667 14.14 18.667 12.6666C18.667 11.1933 17.4737 9.99996 16.0003 9.99996C14.527 9.99996 13.3337 11.1933 13.3337 12.6666C13.3337 14.14 14.527 15.3333 16.0003 15.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6741_37971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentBot24Filled);
export default __webpack_public_path__ + "static/media/fluent_bot-24-filled.f705f6107b0750e1ed61e6f80e12ddd1.svg";
export { ForwardRef as ReactComponent };